<template>
  <div class="about">
    <h1>About Plotz</h1>
    <h1>Team</h1>
    <h2>CEO, Founder</h2>
    <h2>CIO</h2>
  </div>
</template>
